import React from 'react'
import { Icons, Tag } from '@pankod/refine-antd'

import { TTTEStatus } from '../types'

export const PengajuanStatusTag: React.FC<{
  status: TTTEStatus
  isAdmin?: boolean
}> = ({ status, isAdmin = false }) => {
  const config: Record<
    TTTEStatus,
    { color: string; label: string; icon?: React.ReactNode }
  > = {
    menunggu_persetujuan: {
      color: 'default',
      label: 'Menunggu Giliran',
      icon: <Icons.ClockCircleOutlined />,
    }, // default gray tag
    siap_diproses: {
      color: 'warning',
      label: 'Siap Diproses',
      icon: <Icons.AuditOutlined />,
    },
    dalam_proses: {
      color: 'processing',
      label: 'Dalam Proses',
      icon: <Icons.SyncOutlined spin />,
    },
    selesai: {
      color: 'success',
      label: 'Selesai',
      icon: <Icons.CheckCircleFilled />,
    },
    ditolak: { color: 'error', label: 'Ditolak', icon: <Icons.XFilled /> },
    tte_ulang: {
      color: 'warning',
      label: 'TTD Ulang',
      icon: <Icons.ExclamationCircleFilled />,
    },
  }

  if (isAdmin) {
    switch (status) {
      case 'menunggu_persetujuan':
      case 'siap_diproses':
        status = 'dalam_proses'
    }
  }

  const { color, label, icon } = config[status] ?? {
    color: 'default',
    label: status,
  }
  return (
    <Tag icon={icon} color={color}>
      {label}
    </Tag>
  )
}
